module.exports = [
    // blues
    {
        swatch: '305B90',
        shades: [{ id: '002136' }, { id: '014976' }, { id: '006B96' }, { id: '4D93B8' }, { id: 'B4D9F3' }],
    },
    // magentas
    {
        swatch: 'D31996',
        shades: [{ id: '6A0D4B' }, { id: '9E1371' }, { id: 'DC47AB' }, { id: 'E575C0' }, { id: 'EDA3D5' }],
    },
    // purples
    {
        swatch: '6C45C4',
        shades: [{ id: '362362' }, { id: '513493' }, { id: '896AD0' }, { id: 'A78FDC' }, { id: 'C4B5E7' }],
    },
    // oranges
    {
        swatch: 'F76B1D',
        shades: [{ id: 'D64A28' }, { id: 'D8702C' }, { id: 'F9A01B' }, { id: 'FDBA61' }, { id: 'FCDDC6' }],
    },
    // greens
    {
        swatch: '34731A',
        shades: [{ id: '1A3A0D' }, { id: '275614' }, { id: '5C8A46' }, { id: '7FB036' }, { id: 'D4E493' }],
    },
    // grays
    {
        swatch: '4A4A4A',
        shades: [{ id: '131313' }, { id: '252525' }, { id: '383838' }, { id: '6E6E6E' }, { id: '929292' }],
    },
]
